import type { FaireProductEntity } from "../../entity_types/product";

export const p_amahjafc2q: FaireProductEntity = {
  token: "p_amahjafc2q",
  type: "product",
  name: "Refined Stone Bead Necklace – Timeless Everyday Accent",
  brandToken: "b_eow5j1bbc8",
  brandName: "Ellison+Young",
  imageUrl:
    "https://cdn.faire.com/fastly/55a0254ebac34a0d94a63693f38fbc765680d57111f6927d5bfec7da47c40bac.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4998ed10562bcdaaa096a2c65f35532a26bc128627d6e236a3f53b5d95620bf4.jpeg",
    "https://cdn.faire.com/fastly/e36dbc087e8d6a9a8c64584b88c681a63096922b2f7a71b18f4ed569942dbcce.png",
    "https://cdn.faire.com/fastly/95605bbfb9b04098e4439122744411a56b68469bd46326db84a605c0adc15761.png",
    "https://cdn.faire.com/fastly/b6079af9a8d16de6233f72f0436bedb57ab372ce14363fbb6faa02fdedf934ef.png",
    "https://cdn.faire.com/fastly/a6cdc739dc1020e240ca08076145bd3ab99b911a6ae5659f80b51c8eeb30baec.png",
    "https://cdn.faire.com/fastly/e8836ea0a330d422c8fa77c2422f6d6188caae367c58c4f3fc8c6062cb8c3a3a.png",
    "https://cdn.faire.com/fastly/02ff15391b962e05542bfc0dfd64ffea9d6b279f5d9dfa7820aee2a38a7f88b9.jpeg",
    "https://cdn.faire.com/fastly/5f0bb7daa1cade5a8f6bfbe5d06b043bc0a2db1fbb168ba5e802c32f5e55cc40.png",
    "https://cdn.faire.com/fastly/4c06b4db1d0025c29962f837c9a5209f09435165c48cbc4c5aa4573d104c9b5b.jpeg",
    "https://cdn.faire.com/fastly/5a9e0c4224de7737a6735e66a1b0890e3abebb05b4387c5e43f9c4e5e9dd330c.jpeg",
  ],
  priceDollars: 15.5,
  description:
    'Refresh your everyday style with the Refined Stone Bead Necklace – a beautifully crafted strand of polished stone beads designed for effortless, everyday elegance. Whether worn alone or layered, this versatile piece adds natural charm and a touch of sophistication to any look.\n\n• Elegant Stone Beads – Smooth, rounded stones in rich, eye-catching hues\n• Wear-Everywhere Style – A timeless accent that pairs effortlessly with any outfit\n• Layering-Friendly Design – Perfect for stacking with chains or wearing as a standalone statement\n\nDimensions: Approximately 16" w 2" extender\nMaterials: Natural stone beads, gold plated stainless steel\nFeatures: Lead & nickel free, made for long-lasting wear\nImported',
  tags: [],
  msrpDollars: 38.75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:56.004Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
